/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys, Topic } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'
import useAppStore from '@/store/useAppStore'
import {
  DEFAULT_TOPIC_APPLICATION,
  TopicType,
  TopicTypeAndApplicationDic,
  whiteListFilterFn,
} from '@/utils/constants'

export interface GetTopicParam {
  circleID?: string
  connID?: string
  searchType?: number
  pageNo: number
  interaction: number
  topicType: number
}

export const useGetTopics = () => {
  const axios = useContext(AxiosContext)
  const { resetTopicList, setTopicList, updateTopicList } = useAppStore()
  return useMutation({
    mutationKey: [ReactQueryKeys.GET_TOPICS, new Date().getTime()],
    mutationFn: async (data: GetTopicParam) => {
      if (data.pageNo === 1) resetTopicList()
      const response = await axios.api.post('ajax/topics', {
        requestType: 'topicList',
        list: 'mini',
        format: 'json',
        searchType: 1,
        topicApplication: TopicTypeAndApplicationDic[data.topicType] || DEFAULT_TOPIC_APPLICATION,
        ...data,
      })
      const topicData: Record<string, Topic> = {}
      response.data?.myTopics?.forEach((topic: Topic) => {
        if (whiteListFilterFn(topic)) {
          topicData[topic.topicID] = topic
        } else {
          return
        }
      })
      if (data.pageNo === 1) setTopicList(topicData)
      else updateTopicList(topicData)
      return response.data?.myTopics || []
    },
  })
}
